module.exports = __webpack_public_path__ + "static/media/workspace-sm.4b9204ef.jpg";